// extracted by mini-css-extract-plugin
module.exports = {"footer":"ChangePassword_footer__2gwPv"};